<template>
    <div class="data-yearsales">
        <div class="top">
            <div class="top-time">
                <div class="time-select">
                    <div @click="showCalendarPop = true">
                        <span>{{ year }}年</span>
                        <span class="iconfont iconjiantouxia"></span>
                    </div>
                </div>
            </div>
            <div class="color-block">
                <div class="color-item">
                    <div>
                        <span class="num">
                            {{ statisticsYear.sale_volume }}
                        </span>
                        <div class="tip">
                            年销售方量(万方)
                        </div>
                    </div>
                    <div class="perc">
                        <span class="up" v-if="statisticsYear.volume_rate.indexOf('-')===-1">
                            <span class="num-pers">{{ statisticsYear.volume_rate }}</span>
                            <span class="iconfont">&#xe60a;</span>

                        </span>
                        <span class="down" v-else>
                            <span class="iconfont">&#xe609;</span>
                            <span class="num-pers">{{ statisticsYear.volume_rate }}</span>

                        </span>
                        <p class="persent-tip">
                            较去年
                        </p>
                    </div>
                </div>
                <div class="color-item">
                    <div>
                        <span class="num">
                            {{ statisticsYear.sale_amount }}
                        </span>
                        <div class="tip">
                            年销售金额(万元)
                        </div>
                    </div>
                    <div class="perc">
                        <span class="up" v-if="statisticsYear.amount_rate.indexOf('-')===-1">
                            <span class="num-pers">{{ statisticsYear.amount_rate }}</span>
                            <span class="iconfont">&#xe60a;</span>
                        </span>
                        <span class="down" v-else>
                            <span class="num-pers">{{ statisticsYear.amount_rate }}</span>
                            <span class="iconfont">&#xe609;</span>

                        </span>
                        <p class="persent-tip">
                            较去年
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle">
            <h4>月度销售统计</h4>
            <div id="lineChart" class="chart"></div>
        </div>
        <div class="bottom">
            <h4>企业销售统计</h4>
            <div class="address-types">
                <div
                    class="address-item"
                    :class="`color${index%3}`"
                    v-for="(item, index) in telentData"
                    :key="item.enterprise_name"
                >
                    <div class="left padding10">
                        {{ item.short_name }}
                    </div>
                    <div class="right">
                        <div>
                            <div class="num">
                                {{ item.sale_volume }}
                            </div>
                            <div class="lable">
                                销售方量(万方)
                            </div>
                        </div>
                        <div>
                            <div class="num">
                                {{ item.sale_amount }}
                            </div>
                            <div class="lable">
                                销售收入(万元)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                :columns="columns"
                :default-index="defaultIndex"
                @cancel="showCalendarPop = false"
                @confirm="onConfirm"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_blue from '@/assets/images/home/bg_blue.png';
export default {
    data() {
        return {
            year: '',
            startTime: '',
            endTime: '',
            // 图表数据
            data: {
                structure_level: [],
                structure_level_quantity: [],
                structure_level_money: [],
            },
            // 展示日历
            showCalendarPop: false,
            // 日历值
            currentDate: new Date(),
            // 年合计数据
            statisticsYear: {
                sale_volume: 0,
                sale_amount: 0,
                volume_rate: '0',
                amount_rate: '0',
            },
            // 按区域统计
            list: [],
            columns: [],
            defaultIndex: 0,
            monthData: [],
            telentData: [],
        };
    },
    props: {
        filterData: Object,
    },
    watch: {
        filterData() {
            this.getData();
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始化
        init() {
            const date = new Date();
            this.year = date.getFullYear();
            this.setYears();
            this.getData();
        },
        // 设置年份
        setYears() {
            const startYear = 1990;
            for (let i = 0; i < 51; i++) {
                const year = startYear + i;
                if (this.year === year) {
                    this.defaultIndex = i;
                }
                this.columns.push(year);
            }
        },
        onConfirm(value) {
            this.showCalendarPop = false;
            this.year = value;
            this.getData();
        },
        // 渲染图表
        renderChart() {
            const lastDay = this.getLastDay(this.year, 12);
            this.startTime = this.year + '-01-01 00:00:00';
            this.endTime = this.year + '-12-' + lastDay + ' 23:59:59';
            this.getData();
        },

        // 确认时间选择
        confirmDate(value) {
            this.showCalendarPop = false;
            this.year = this.formatDate(value);
            this.handleStatisticsYear();
        },
        // 时间格式化
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            return y;
        },
        async getData() {
            const res = await this.getStatisticsYear();
            this.monthData = res.monthSalesDatas;
            res.enterpriseSalesDatas.forEach(item => {
                item.short_name = item.enterprise_name.replace('商混', '').replace('砼享云', '');
            });
            this.telentData = res.enterpriseSalesDatas;
            this.statisticsYear.sale_volume = res.sale_volume;
            this.statisticsYear.sale_amount = res.sale_amount;
            if (res.sale_volume_lastyear === 0) {
                this.statisticsYear.volume_rate = '0';
            } else {
                this.statisticsYear.volume_rate = ((res.sale_volume - res.sale_volume_lastyear) / res.sale_volume_lastyear * 100).toFixed(2);
            }
            if (res.sale_amount_lastyear === 0) {
                this.statisticsYear.volume_rate = '0';
            } else {
                this.statisticsYear.amount_rate = ((res.sale_amount - res.sale_amount_lastyear) / res.sale_amount_lastyear * 100).toFixed(2);
            }
            this.handleStatisticsMonth();
            this.$forceUpdate();
        },
        // 处理年总计销量统计信息
        async handleStatisticsMonth() {
            const structure_level = [];
            const structure_level_quantity = [];
            const structure_level_money = [];
            this.monthData.map(item => {
                const date = item.month + '月';
                structure_level.push(date);
                structure_level_quantity.push(item.sale_volume);
                structure_level_money.push(item.sale_amount);
            });
            this.data.structure_level = structure_level;
            this.data.structure_level_quantity = structure_level_quantity;
            this.data.structure_level_money = structure_level_money;
            this.initLineChart();
        },

        // 获取年总计销量统计信息
        getStatisticsYear() {
            const path = '/interfaceApi/report/SalesReport/get_statistics_year/' + this.year;
            return this.$axios.$post(path, this.filterData);
        },
        // 获取指定年月最后一天
        getLastDay(year, month) {
            let nyear = year;
            let nmonth = month++;
            if (month > 12) {
                nmonth -= 12;
                nyear++;
            }
            const n_date = new Date(nyear, nmonth, 1);
            return (new Date(n_date.getTime() - 1000 * 60 * 60 * 24)).getDate();
        },
        // 量价结构分析
        initLineChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: '13%',
                    right: '13%',
                },
                legend: {
                    data: ['销售方量', '销售收入'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.data.structure_level,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                            // rotate: 40,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(万方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小

                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(万元)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销售方量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(85,167,254,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(62,121,197,1)', // 100% 处的颜色
                            }], false),
                        },
                        label: {
                            show: false,
                            position: 'top',
                            fontSize: '12',
                            color: 'rgba(62,121,197,1)',
                            lineHeight: 22,
                            padding: [0, 10, 4, 10],
                            backgroundColor: {
                                image: bg_blue,
                            },
                        },
                        barWidth: 15,
                        data: this.data.structure_level_quantity,
                    },
                    {
                        name: '销售收入',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        label: {
                            show: false,
                            position: 'bottom',
                            fontSize: '12',
                            padding: 0,
                            color: '#FA8436',
                        },
                        yAxisIndex: 1,
                        data: this.data.structure_level_money,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>

<style lang="stylus">
    .data-yearsales
        height 100%
        overflow-y auto
        .middle
            margin-top 15rpx
            padding 15rpx
            background-color #fff
            .chart
                height 256rpx
        .bottom
            margin-top 15rpx
            padding 15rpx
            background-color #fff
            .address-types
                margin-top 15rpx
                .address-item
                    height 50rpx
                    display flex
                    border-radius 4rpx
                    margin-bottom 20rpx
                    .left
                        width 30rpx
                        border-radius 4rpx 0 0 4rpx
                        padding 6rpx 7rpx
                        font-size 12rpx
                        color #fff
                        line-height 12rpx
                    .padding10{
                        padding 10rpx 7rpx
                    }
                    .right
                        display flex
                        width calc(100% - 30rpx)
                        >div
                            flex 1
                            text-align center
                            &:nth-child(1)
                                position relative
                                .num
                                    color #5588F1
                                &:after
                                    content ''
                                    position absolute
                                    width 1px
                                    height 15rpx
                                    background #D7D7D7
                                    right 0
                                    top 20rpx
                            &:nth-child(2)
                                .num
                                    color #FA8436
                        .num
                            font-size 15rpx
                            margin-top 6rpx
                        .lable
                            font-size 12rpx
                            color #666666
                    &.color0
                        border 1px solid #D3DCF3
                        .left
                            background-color #3E67C6
                        .right
                            background rgba(62, 103, 198, 0.04)
                    &.color1
                        border 1px solid #C1E3DC
                        .left
                            background-color #4EA496
                        .right
                            background rgba(78, 164, 150, 0.04)
                    &.color2
                        border 1px solid #CFE6F8
                        .left
                            background-color #3089CC
                        .right
                            background rgba(48, 137, 204, 0.04)
        .top
            background-color #fff
            .top-time
                padding 15rpx
                .time-select
                    box-shadow: 0 2rpx 4rpx 0 rgba(84, 148, 243, 0.2)
                    border-radius 4rpx
                    border 1px solid #D7D7D7
                    height 36rpx
                    line-height 36rpx
                    text-align center
                    font-size 14rpx
                    .iconjiantouxia
                        margin-left 10rpx
                        font-size 12rpx
                        color #979EA7
                .time-types
                    display flex
                    margin-top 15rpx
                    .type-item
                        width calc(100% - 66rpx)
                        height 30rpx
                        text-align center
                        line-height 28rpx
                        background #FFFFFF
                        box-shadow 0 2rpx 4rpx 0 rgba(84, 148, 243, 0.2)
                        border-radius 4rpx
                        border 1px solid #D7D7D7
                        font-size 14rpx
                        color #666
                        &:nth-child(1)
                            margin-right 22rpx
                        &:nth-child(2)
                            margin-right 22rpx
                        &:nth-child(3)
                            margin-right 22rpx
                        &.active
                            background #3495FB
                            box-shadow 0 2rpx 4rpx 0 #5494F3
                            border-radius 4rpx
                            border 1px solid #0E84FF
                            color #fff
            .color-block
                padding 0 15rpx 15rpx 15rpx
                display flex
                .color-item
                    width calc(100% - 15rpx)
                    text-align left
                    padding 15rpx 8rpx
                    display: flex;
                    justify-content: space-around;
                    align-items baseline
                    .num
                        font-size 21rpx
                    .tip
                        font-size 12rpx
                        color #666666
                    .perc
                        text-align right ;
                        .num-pers
                            font-size 14rpx;
                        .iconfont
                            font-size 8rpx;
                        .up
                            color #D6010F!important
                        .down
                            color #18A001!important
                        .persent-tip
                            font-size 13rpx
                            color #666666
                            margin-left 5rpx
                    &:nth-child(1)
                        background: rgba(85, 136, 241, 0.06)
                        margin-right 15rpx
                        .num
                            color #5588F1
                    &:nth-child(2)
                        background: rgba(250, 132, 54, 0.06)
                        .num
                            color #FA8436
</style>
